// General 
export const CLASS_MARKING_UPDATE_LCS_IDS = "CLASS_MARKINMG_UPDATE_LCS_IDS";
export const CLASS_MARKING_CLEAR = "CLASS_MARKING_CLEAR";
export const CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS = "CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS";
export const CLASS_MARKING_TOGGLE_LOADING_UNIT_OF_LEARNING_STUDENTS = "CLASS_MARKING_TOGGLE_LOADING_UNIT_OF_LEARNING_STUDENTS";
export const CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING = "CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING";
export const CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING_METHOD = "CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING_METHOD";
export const updateClassMarkingLcsIds = (lcsIds) => ({
  type: CLASS_MARKING_UPDATE_LCS_IDS,
  payload: lcsIds,
});
export const clearClassMarking = () => ({
  type: CLASS_MARKING_CLEAR,
});
export const updateUnitOfLearningStudents = (students) => ({
  type: CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS,
  payload: students,
});
export const updateUnitOfLearningStudentsMethod = (method = 'POST', data) => ({
  type: CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING_METHOD,
  payload: { method, data },
});
export const toggleLoadingUnitOfLearningStudents = (loading = false) => ({
  type: CLASS_MARKING_TOGGLE_LOADING_UNIT_OF_LEARNING_STUDENTS,
  payload: loading,
});

// Student view
export const CLASS_MARKING_TOGGLE_LOADING_STUDENT = "CLASS_MARKING_TOGGLE_LOADING_STUDENT";
export const CLASS_MARKING_UPDATE_STUDENT = "CLASS_MARKINMG_UPDATE_STUDENT";
export const CLASS_MARKING_UPDATE_STUDENT_GRANULAR_STEP_LOG_MARKING = "CLASS_MARKING_UPDATE_STUDENT_GRANULAR_STEP_LOG_MARKING";
export const CLASS_MARKING_COMPLETED_TYPE = "CLASS_MARKING_COMPLETED_TYPE";
export const CLASS_MARKING_UPDATE_MODE = "CLASS_MARKING_UPDATE_MODE";

export const toggleLoadingClassMarkingStudent = (loading = false) => ({
  type: CLASS_MARKING_TOGGLE_LOADING_STUDENT,
  payload: loading,
});
export const updateClassMarkingStudent = (student) => ({
  type: CLASS_MARKING_UPDATE_STUDENT,
  payload: student,
});
export const updateClassMarkingStudentGranularSteps = (lcId, completed, granularSteps, logMarking) => ({
  type: CLASS_MARKING_UPDATE_STUDENT_GRANULAR_STEP_LOG_MARKING,
  payload: { lcId, completed, granularSteps, logMarking },
});
export const updateClassMarkingCompletedType = (completedType) => ({
  type: CLASS_MARKING_COMPLETED_TYPE,
  payload: completedType,
});
export const updateClassMarkingMode = (data, actionData = 'add') => ({
  type: CLASS_MARKING_UPDATE_MODE,
  payload: {data, actionData},
});


// Guttman chart
export const CLASS_MARKING_UPDATE_VIEW_GUTTMAN_CHART = "CLASS_MARKING_UPDATE_VIEW_GUTTMAN_CHART";
export const CLASS_MARKING_UPDATE_TYPE_GUTTMAN_CHART = "CLASS_MARKING_UPDATE_TYPE_GUTTMAN_CHART";

export const updateViewGuttmanChart = (type = 'general') => ({
  type: CLASS_MARKING_UPDATE_VIEW_GUTTMAN_CHART,
  payload: type,
});
export const updateGuttmanChartType = (type = 'completedTeacher') => ({
  type: CLASS_MARKING_UPDATE_TYPE_GUTTMAN_CHART,
  payload: type,
});

// Bulk marking

export const CLASS_MARKING_UPDATE_STEP_BULK_MARKING = "CLASS_MARKING_UPDATE_STEP_BULK_MARKING";
export const CLASS_MARKING_UPDATE_STUDENTS_SELECTED_BULK_MARKING = "CLASS_MARKING_UPDATE_STUDENTS_SELECTED_BULK_MARKING";
export const CLASS_MARKING_UPDATE_ERROR_BULK_MARKING = "CLASS_MARKING_UPDATE_ERROR_BULK_MARKING";
export const CLASS_MARKING_UPDATE_BULK_MARKING_DATA = "CLASS_MARKING_UPDATE_BULK_MARKING_DATA";
export const CLASS_MARKING_UPDATE_BULK_GRANULAR_STEP_LOG_MARKING = "CLASS_MARKING_UPDATE_BULK_GRANULAR_STEP_LOG_MARKING";

export const updateStepBulkMarking = (step) => ({
  type: CLASS_MARKING_UPDATE_STEP_BULK_MARKING,
  payload: step,
});

export const updateStudentsSelectedBulkMarking = (students = []) => {
  return {
    type: CLASS_MARKING_UPDATE_STUDENTS_SELECTED_BULK_MARKING,
    payload: students,
  };
}

export const updateErrorBulkMarking = (error) => {
  return {
    type: CLASS_MARKING_UPDATE_ERROR_BULK_MARKING,
    payload: error,
  };
}

export const updateBulkMarkingData = (data) => {
  return {
    type: CLASS_MARKING_UPDATE_BULK_MARKING_DATA,
    payload: data,
  };
};

export const updateBulkMarkingGranularSteps = (lcId, granularSteps, logMarking) => ({
  type: CLASS_MARKING_UPDATE_BULK_GRANULAR_STEP_LOG_MARKING,
  payload: { lcId, granularSteps, logMarking },
});

// Learning growth
export const CLASS_MARKING_UPDATE_LEARNING_GROWTH = "CLASS_MARKING_UPDATE_LEARNING_GROWTH";
export const CLASS_MARKING_TOGGLE_LOADING_LEARNING_GROWTH = "CLASS_MARKING_TOGGLE_LOADING_LEARNING_GROWTH";
export const CLASS_MARKING_UPDATE_LEARNING_GROWTH_VIEW = "CLASS_MARKING_UPDATE_LEARNING_GROWTH_VIEW";
export const CLASS_MARKING_UPDATE_LEARNING_GROWTH_TYPE = "CLASS_MARKING_UPDATE_LEARNING_GROWTH_TYPE";

export const updateLearningGrowth = (data) => ({
  type: CLASS_MARKING_UPDATE_LEARNING_GROWTH,
  payload: data,
});

export const toggleLoadingLearningGrowth = (loading = false) => ({
  type: CLASS_MARKING_TOGGLE_LOADING_LEARNING_GROWTH,
  payload: loading,
});

export const updateLearningGrowthView = (view = 'column') => ({
  type: CLASS_MARKING_UPDATE_LEARNING_GROWTH_VIEW,
  payload: view,
});
export const updateLearningGrowthType = (type = 'completedTeacher') => ({
  type: CLASS_MARKING_UPDATE_LEARNING_GROWTH_TYPE,
  payload: type,
});

// Dashboard 
export const CLASS_MARKING_DASHBOARD_UPDATE_DASHBOARD = "CLASS_MARKING_DASHBOARD_UPDATE_DASHBOARD";
export const CLASS_MARKING_DASHBOARD_UPDATE_LEARNING_CONTINUUM = "CLASS_MARKING_DASHBOARD_UPDATE_LEARNING_CONTINUUM";
export const CLASS_MARKING_DASHBOARD_TOGGLE_LOADING = "CLASS_MARKING_DASHBOARD_TOGGLE_LOADING";


export const updateDashboardDatasets = (data) => ({
  type: CLASS_MARKING_DASHBOARD_UPDATE_DASHBOARD,
  payload: data,
});

export const toggleLoadingDashboard = (loading = false) => ({
  type: CLASS_MARKING_DASHBOARD_TOGGLE_LOADING,
  payload: loading,
});

export const updateDashboardLearningContinuum = (data) => ({
  type: CLASS_MARKING_DASHBOARD_UPDATE_LEARNING_CONTINUUM,
  payload: data,
});

// Group marking
export const CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENTS = "CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENTS";
export const CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENT = "CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENT";
export const CLASS_MARKING_GROUP_MARKING_TOGGLE_LOADING = "CLASS_MARKING_GROUP_MARKING_TOGGLE_LOADING";

export const updateGroupMarkingStudents = (students) => ({
  type: CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENTS,
  payload: students,
});

export const updateGroupMarkingStudent = (student) => ({
  type: CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENT,
  payload: student,
});

export const toggleLoadingGroupMarking = (loading = false) => ({
  type: CLASS_MARKING_GROUP_MARKING_TOGGLE_LOADING,
  payload: loading,
});

